// extracted by mini-css-extract-plugin
module.exports =  {"errorView":"JqWeMyPL","logo":"ruLDWJDb","link":"yLy2t8d0"};